export default __webpack_public_path__ + "static/media/to-do@1.5x.e6ea672a.svg";